var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_487)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 100,
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3333 139.856C75.5553 148.745 87.778 155.856 100 155.856C112.222 155.856 124.445 148.745 136.667 139.856C126.592 136.789 121.481 132.212 121.333 126.123C121.333 125.037 121.341 123.496 121.349 120.602C121.349 120.142 121.35 119.672 121.352 119.19C121.372 111.43 121.405 101.19 121.451 90.79C131.005 78.4054 127.495 63.886 124.501 64.248C120.831 64.6947 89.0287 34.516 82.9287 32.9687C76.8287 31.4214 61.3333 36.4167 58.6667 50.3334C56 64.25 54.8853 99.3287 65 113.333C67.8782 117.319 72.4116 118.878 78.6 118.01C78.6087 120.923 78.626 122.557 78.6667 125.856C78.5873 132.222 73.4767 136.793 63.3333 139.856Z",
    fill: "url(#paint0_linear_304_487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6667 118C93.3333 116.333 102.667 110 102.667 110C102.667 110 92 123.333 78.6667 126V118Z",
    fill: "#FC9F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.333 91C130.927 79.9533 149.333 57.4553 133.467 43.4553C128.133 17.4553 98.6667 20.3333 79 26.3333C65.782 30.366 55.8 38.3333 53.6667 32.3333C40.3334 43.4553 47.0107 54.3333 55.8 57.4553C63.7774 60.2887 77.2667 63.122 100.204 60.4553C104.301 59.9787 103.443 72.5273 105.633 73.884C108.917 75.9193 111.467 63.122 120.472 66.9647C129.477 70.8073 124.133 88.6247 114.467 88.6247C111.133 88.6247 109.467 97.7893 118.467 102.123C125 105.333 123.349 98.178 126.333 91Z",
    fill: "url(#paint1_linear_304_487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 160.205C176.347 173.11 180 202.872 180 202.872H20C20 202.872 23.6547 173.107 30 160.205C36.3453 147.304 73.4 135.338 73.4 135.338C93.8753 143.333 106.405 143.333 126.581 135.333C126.581 135.333 163.653 147.301 170 160.205Z",
    fill: "url(#paint2_linear_304_487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.667 140L108 201.333H92L95.3333 140C95.3333 140 98.4447 136.667 100 136.667C101.555 136.667 104.667 140 104.667 140Z",
    fill: "url(#paint3_linear_304_487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.426 152.461L94.9426 146.404L95.3333 140C97.4075 137.778 98.9631 136.667 100 136.667C101.037 136.667 102.592 137.778 104.667 140L105.427 152.461H105.426Z",
    fill: "#645050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 136.661L93.3333 148.667L72.6667 136L78.6667 127.333L100 135.214L121.333 127.333L127.333 136L106.667 148.667L100 136.661Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304_487",
    x1: 96.7478,
    y1: 32.698,
    x2: 96.7478,
    y2: 155.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_304_487",
    x1: 92.9603,
    y1: 22.2586,
    x2: 92.9603,
    y2: 102.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_304_487",
    x1: 100,
    y1: 135.333,
    x2: 100,
    y2: 202.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_304_487",
    x1: 100,
    y1: 136.667,
    x2: 100,
    y2: 201.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#806A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#665654"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.45f14bbec00a5d6af73d195d4905e4cd.svg";
export { ForwardRef as ReactComponent };